
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { ValidationProvider } from 'vee-validate';
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormTextarea from "@/components/form/FormTextarea.vue";
import _ from 'lodash';

@Component({
  components: {
    ValidationProvider,
    FormGroup,
    FormTextarea
  }
})
export default class AdditionalNotes extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;

  localFormData: Record<string, any> = {};

@Watch('formData', { immediate: true, deep: true })
onFormDataChange(newVal: Record<string, any>) {
this.localFormData = _.cloneDeep(newVal);
}

updateField(field: string, value: any) {
this.localFormData[field] = value;
this.$emit('update:formData', this.localFormData);
}
}
